import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		viewAll: {
			fontSize: '14px',
			fontWeight: 400,
			color: '#1B1A7C',
			marginBottom: '5px',
			cursor: 'pointer',
			marginLeft: '10px',
		},
		valuesSection: {
			marginTop: '12px',
			position: 'relative',
		},
		valuesLabel: {
			color: '#1B1A7C',
			fontSize: '14px',
			marginBottom: '5px',
			marginRight: '10px',
		},
		valuesOuterContainer: {
			marginTop: '0px',
		},
		valuesOuterContainerMobile: {
			alignContent: 'flex-start',
			alignItems: 'flex-start',
			// height: '30px',
			overflowY: 'hidden',
		},
		valuesInnerContainer: {
			width: 'auto',
			alignItems: 'center',
		},
		valuesInnerContainerMobile: {
			overflowX: 'auto',
			flexWrap: 'nowrap',
			// height: '50px',
		},
		valueItem: {
			color: '#424242',
			fontSize: '14px',
			fontWeight: 700,
			marginBottom: '5px',
			whiteSpace: 'nowrap',
			position: 'relative',
		},
		valueSeparator: {
			'&:before': {
				width: '5px',
				height: '5px',
				content: "' '",
				backgroundColor: '#424242',
				borderRadius: '50%',
				display: 'inline-flex',
				margin: '0px 10px',
				verticalAlign: '10%',
			},
		},
		editIconLabel: {
			paddingLeft: 6,
			paddingRight: 6,
		},
		editRootElement: {
			background: '#fff',
			position: 'absolute',
			top: -1,
			right: 0,
			[theme.breakpoints.down('md')]: {
				top: 0,
				right: 5,
				[theme.breakpoints.only('xs')]: {
					width: 30,
					height: 30,
					'& svg': {
						fontSize: '1.2rem'
					}
				}
			},
		},
		saveEdit: {
			position: 'relative',
			display: 'inline',
			margin: '2px',
			fontSize: 16,
			border: '1px solid #FC2652',
			padding: '0 8px',
			borderRadius: 12,
			color: '#FC2652',
			cursor: 'pointer',
		},
		cancelEdit: {
			position: 'relative',
			display: 'inline',
			margin: '2px',
			fontSize: 16,
			border: '1px solid grey',
			padding: '0 8px',
			borderRadius: 12,
			color: 'grey',
			cursor: 'pointer',
		},
		saveCancelButtons: {
			position: 'absolute',
			top: '0px',
			right: '0px',
		},
		saveSuccess: {
			position: 'absolute',
			right: 0,
			top: 6,
			fontSize: 13,
			color: '#FC2652',
		},
	})
